import { STRING_ARRAY_FILTER_OPERATION } from '../filter/operation.js';

export const DROPDOWN_STRING_ARRAY_OPTIONS = [
    [STRING_ARRAY_FILTER_OPERATION.beginsWith.id, STRING_ARRAY_FILTER_OPERATION.endsWith.id],
    [
        STRING_ARRAY_FILTER_OPERATION.containsLoose.id,
        STRING_ARRAY_FILTER_OPERATION.containsStrict.id,
        STRING_ARRAY_FILTER_OPERATION.doesNotContain.id,
    ],
] as const;
